module.exports = __webpack_public_path__ + "img/catprotection.e996581.png";